<div class="d-flex justify-content-center">
  @if (flagsCount() > 1) {
    <span class="claim-flag bg-pink text-white" [ngClass]="{ 'claim-flag-small': size() === 'small' }">
      <chitin-icon icon="fa fa-solid fa-exclamation" class="d-block" style="margin: var(--space-x-3px) var(--space-x-7px)" />
    </span>
  }
</div>
